import { useAuth } from "react-oidc-context";

export const useUserEmailAddress = (): string | undefined => {
  const auth = useAuth();
  return auth.user?.profile?.email;
};
